export enum apiHeader {
  APPLICATION_JSON = 'application/json',
  IMAGE = 'image/jpeg',
}
